import { createAction } from 'redux-actions';
export var SET_ORDER = 'SET_ORDER';
export var SET_LAST_EXCHANGE = 'SET_LAST_EXCHANGE';
export var setOrder = createAction(SET_ORDER, function (order) { return order; });
export var setLastExchange = createAction(SET_LAST_EXCHANGE, function (exchangeOrder) { return exchangeOrder; });
